import { useEffect } from "react";
import { useQuery } from "react-query";
import { fetchGetRequests } from "infrastructure/helpers/fetchServerRequests";
import { NOTIFICATIONS_FEED_API } from "../constants";
import { extractNotificationsRowsFromApiData } from "../utils/extractNotificationsRowsFromApiData";
import { mapApiNotificationRecordsToItems } from "../utils/mapApiNotificationRecordsToItems";
import { NotificationItem } from "../types";

type UseNotificationsApiSyncOptions = {
  enabled: boolean;
  hydrateFromApi: (items: NotificationItem[]) => void;
};

const NOTIFICATIONS_POLL_INTERVAL_MS = 30_000;

export const useNotificationsApiSync = ({
  enabled,
  hydrateFromApi,
}: UseNotificationsApiSyncOptions) => {
  const query = useQuery(
    ["company-notifications-feed"],
    () => fetchGetRequests(NOTIFICATIONS_FEED_API),
    {
      enabled,
      refetchOnWindowFocus: true,
      refetchInterval: enabled ? NOTIFICATIONS_POLL_INTERVAL_MS : false,
      refetchIntervalInBackground: false,
    }
  );

  useEffect(() => {
    if (!enabled) {
      hydrateFromApi([]);
      return;
    }

    const rows = extractNotificationsRowsFromApiData(query.data?.response);
    const mappedItems = mapApiNotificationRecordsToItems(rows);
    hydrateFromApi(mappedItems);
  }, [enabled, hydrateFromApi, query.data]);

  return {
    refreshNotifications: query.refetch,
    isLoading: query.isLoading,
  };
};
